import { render } from "./CEditPage.vue?vue&type=template&id=2725d5de"
import script from "./CEditPage.vue?vue&type=script&lang=js"
export * from "./CEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__